export enum CreditCardTypes {

    Unknown = 0,
    VISA = 1,
    MasterCard = 2,
    Discover = 3,
    AmericanExpress = 4,
    JCB = 5,
    EnRoute = 6,
    DinersClub = 7

}

export interface ICreditCardResponse {

    ID: number;
    LastFour: string;
    ExpMonth: number;
    ExpYear: number;
    CardType: CreditCardTypes;
    IsDefault: boolean;
    DateTimeLastUpdate: Date;
    DateTimeCreated: Date;
    DateTimeLastUsed: Date;
    Status: string;
    FirstName: string;
    LastName: string;
    Address01: string;
    City: string;
    State: string;
    PostalCode: string;
    Country: string;
    // FixDates();

}

export class CreditCardResponse implements ICreditCardResponse {

    ID: number;
    LastFour: string;
    ExpMonth: number;
    ExpYear: number;
    CardType: CreditCardTypes;
    IsDefault: boolean;
    DateTimeLastUpdate: Date;
    DateTimeCreated: Date;
    DateTimeLastUsed: Date;
    Status: string;
    FirstName: string;
    LastName: string;
    Address01: string;
    City: string;
    State: string;
    PostalCode: string;
    Country: string;

    // public FixDates() {
    //     this.DateTimeCreated = new Date(this.DateTimeCreated);
    //     this.DateTimeLastUpdate = new Date(this.DateTimeLastUpdate);
    //     this.DateTimeLastUsed = new Date(this.DateTimeLastUsed);
    // }


    public static GetCreditCardTypeFromString(type: string): CreditCardTypes {

        switch (type) {

            case "visa":
                return CreditCardTypes.VISA;

            case "mastercard":
                return CreditCardTypes.MasterCard;

            case "discover":
                return CreditCardTypes.Discover;

            case "amex":
                return CreditCardTypes.AmericanExpress;

            case "jcb":
                return CreditCardTypes.JCB;

            case "":
                return CreditCardTypes.EnRoute;

            case "dinersclub":
                return CreditCardTypes.DinersClub;

            default:
                return CreditCardTypes.Unknown;
        }

    }

}


export class CreditCardResponseArray extends Array<CreditCardResponse> {

    constructor(...items: CreditCardResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, CreditCardResponseArray.prototype);
    }

    public InitFromJSON() {

        if (this.length == 0)
            return;

        this.forEach((item) => {
            Object.setPrototypeOf(item, CreditCardResponse.prototype);
            // item.FixDates();
        })
    }

}